import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Page } from '../entities/pages/page';

import { Bulletin } from './bulletin';
import { BulletinFilter } from './bulletin-filter';
import { BulletinFile } from './bulletin-file';
import { BulletinReport } from './bulletin-report';
import { Pageable } from '../entities/pages/pageable';
import { ResultMessage } from '../entities/result-message';


const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable({ providedIn: 'root' })
export class BulletinService {

    private api_url = `${environment.ApiUrl}/bulletin`;

    constructor(private http: HttpClient) { }

    search(filter: BulletinFilter) {
        const url = `${this.api_url}/filter`;
        return this.http.post<Bulletin[]>(url, filter, httpOptions);
    }
    searchNew(filter: BulletinFilter, pageable: Pageable) {

        const url = `${this.api_url}/filter-new`;
        const params = new HttpParams()
            .set('page', pageable.pageNumber.toString())
            .set('size', pageable.pageSize.toString())

        return this.http.post<ResultMessage<Page<BulletinFile>>>(url, filter, { params });

    }

    find(id: number) {
        const url = `${this.api_url}/${id}`;
        return this.http.get<Bulletin>(url, httpOptions);
    }

    findByCode(code: string) {
        const url = `${this.api_url}/code/${code}`;
        return this.http.get<Bulletin>(url, httpOptions);
    }

    findExcept(id: number, filter: string) {
        const url = `${this.api_url}/except/${id}/${filter}`;
        return this.http.get<Bulletin[]>(url, httpOptions);
    }

    save(bulletin: Bulletin, user: string) {
        return this.http.post<Bulletin>(`${this.api_url}/${user}`, bulletin, httpOptions);
    }

    update(bulletin: Bulletin, user: string) {
        return this.http.put<Bulletin>(`${this.api_url}/${user}`, bulletin, httpOptions);
    }

    delete(id: number) {
        const url = `${this.api_url}/${id}`;
        return this.http.delete(url, httpOptions);
    }

    upload(id: number, replace: boolean, attach: Blob) {
        const url = `${this.api_url}/${id}/${replace}/upload`;
        const formData = new FormData();
        formData.append('attach', attach);

        return this.http.post<BulletinFile>(url, formData);
    }

    download(file: BulletinFile, report: BulletinReport, user: string) {
        const url = `${this.api_url}/${file.id}_${user}/download`;
        return this.http.post(url, report, { responseType: 'blob' });
    }

    deleteFile(file: BulletinFile) {
        const url = `${this.api_url}/${file.bulletin.id}/${file.id}`;
        return this.http.delete(url, httpOptions);
    }
}